module.exports = __webpack_public_path__ + "img/icon-xxzy.cb3565c7.png";